// extracted by mini-css-extract-plugin
export default {"wrapper":"ListUser_wrapper__PXaBl","inner":"ListUser_inner__2BlQq","table-action":"ListUser_table-action__xm6sL"};